import React, { useEffect } from 'react';
import LoginSignUpContainer from 'containers/LoginSignUpContainer';
import { useHistory } from 'react-router-dom';
import useSearchParams from 'hooks/useSearchParams';
import { getPath } from 'utils/RouteHelper';

const CSS = require('./LoggedOut.less');

interface LoggedOutProps {
  title: any;
}

function LoggedOut({ title }: LoggedOutProps) {
  const history = useHistory();
  const searchParams = useSearchParams();

  useEffect(() => {
    const returnTo = searchParams.get('returnTo');
    if (returnTo) {
      return;
    }

    searchParams.set('returnTo', getPath());
    history.replace({
      search: searchParams.toString(),
      pathname: history.location.pathname
    });
  }, [history, searchParams]);
  return (
    <div className={CSS.Container}>
      <h1 className={CSS.Title}>{title}</h1>
      <LoginSignUpContainer />
    </div>
  );
}

export default LoggedOut;
